import React from 'react';
import './Projects.css';

function Projects() {
  const projects = [
    {
      title: 'Cloud Monitoring Stack',
      description: 'Designed and deployed a complete observability stack with Prometheus, Loki, and Grafana on EKS. Built comprehensive dashboards and alerting systems for real-time infrastructure monitoring.',
      technologies: ['Prometheus', 'Grafana', 'Loki', 'EKS'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <rect x="5" y="5" width="50" height="40" rx="3" stroke="currentColor" strokeWidth="2"/>
          <path d="M10 35 L15 30 L20 32 L25 25 L30 28 L35 20 L40 25 L45 22 L50 27" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="50" cy="27" r="2" fill="currentColor"/>
          <rect x="15" y="50" width="8" height="5" fill="currentColor"/>
          <rect x="26" y="50" width="8" height="5" fill="currentColor"/>
        </svg>
      )
    },
    {
      title: 'Secure VPN Solution',
      description: 'Implemented a scalable WireGuard VPN for multi-team access with split tunneling and internal DNS resolution. Ensured secure remote access across distributed teams.',
      technologies: ['WireGuard', 'VPN', 'DNS', 'Networking'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <path d="M30 5 L50 15 L50 30 Q50 45 30 55 Q10 45 10 30 L10 15 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <path d="M25 30 L28 33 L35 25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    {
      title: 'CI/CD Automation',
      description: 'Created automated pipelines for building, testing, and deploying microservices using Bitbucket and Helm. Reduced deployment time and increased reliability with GitOps workflows.',
      technologies: ['Bitbucket', 'Helm', 'ArgoCD', 'Microservices'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <path d="M10 30 L20 30 M20 20 L20 40 L30 30 L20 20 M30 30 L40 30 M40 20 L40 40 L50 30 L40 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="5" cy="30" r="3" fill="currentColor"/>
          <circle cx="55" cy="30" r="3" fill="currentColor"/>
        </svg>
      )
    },
    {
      title: 'Cloud Migration',
      description: 'Migrated on-premises workloads to AWS using Terraform, improving scalability, availability, and cost efficiency. Implemented infrastructure as code best practices for repeatable deployments.',
      technologies: ['AWS', 'Terraform', 'Migration', 'IaC'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <path d="M5 30 L20 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <path d="M20 30 L35 30" stroke="currentColor" strokeWidth="3" strokeDasharray="5,5"/>
          <path d="M35 30 L50 15 M35 30 L50 30 M35 30 L50 45" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <rect x="0" y="20" width="15" height="20" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M45 10 Q 40 10 40 15 Q 30 15 30 25 Q 30 35 40 35 L 55 35 Q 58 35 58 32 Q 58 28 55 28 Q 55 18 48 18 Q 48 10 45 10" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      )
    },
    {
      title: 'IT Infrastructure Optimization',
      description: 'Streamlined endpoint management, monitoring, and security across distributed environments. Implemented RMM tools and automated patch management for improved operational efficiency.',
      technologies: ['Intune', 'SCCM', 'Endpoint Management', 'Automation'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <path d="M30 5 L55 18 L55 42 L30 55 L5 42 L5 18 Z" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="30" cy="30" r="8" fill="currentColor"/>
          <path d="M30 22 L30 10 M30 38 L30 50 M22 30 L10 30 M38 30 L50 30" stroke="currentColor" strokeWidth="2"/>
        </svg>
      )
    },
    {
      title: 'Log Management System',
      description: 'Deployed Filebeat and OpenSearch for centralized log analysis and performance troubleshooting. Enabled real-time log aggregation and search capabilities across all services.',
      technologies: ['Filebeat', 'OpenSearch', 'ELK', 'Log Analysis'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <rect x="10" y="10" width="40" height="40" rx="3" stroke="currentColor" strokeWidth="2"/>
          <line x1="15" y1="20" x2="45" y2="20" stroke="currentColor" strokeWidth="2"/>
          <line x1="15" y1="27" x2="40" y2="27" stroke="currentColor" strokeWidth="2"/>
          <line x1="15" y1="34" x2="45" y2="34" stroke="currentColor" strokeWidth="2"/>
          <line x1="15" y1="41" x2="35" y2="41" stroke="currentColor" strokeWidth="2"/>
          <circle cx="50" cy="15" r="5" fill="currentColor"/>
        </svg>
      )
    },
    {
      title: 'Access & Secrets Management',
      description: 'Implemented AWS Secrets Manager with Kubernetes External Secrets Operator for secure secret distribution. Eliminated hardcoded credentials and enabled dynamic secret rotation.',
      technologies: ['AWS Secrets Manager', 'External Secrets', 'Kubernetes', 'Security'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <rect x="20" y="25" width="20" height="25" rx="2" stroke="currentColor" strokeWidth="2"/>
          <path d="M25 25 L25 18 Q25 10 30 10 Q35 10 35 18 L35 25" stroke="currentColor" strokeWidth="2" fill="none"/>
          <circle cx="30" cy="35" r="3" fill="currentColor"/>
          <line x1="30" y1="38" x2="30" y2="43" stroke="currentColor" strokeWidth="2"/>
        </svg>
      )
    },
    {
      title: 'Infrastructure Documentation',
      description: 'Developed internal documentation portals and automated system health dashboards for teams. Created comprehensive runbooks and knowledge bases for operational excellence.',
      technologies: ['Documentation', 'Dashboards', 'Knowledge Management', 'Automation'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <rect x="15" y="5" width="30" height="50" rx="2" stroke="currentColor" strokeWidth="2"/>
          <line x1="20" y1="15" x2="40" y2="15" stroke="currentColor" strokeWidth="2"/>
          <line x1="20" y1="22" x2="40" y2="22" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="20" y1="28" x2="35" y2="28" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="20" y1="35" x2="40" y2="35" stroke="currentColor" strokeWidth="1.5"/>
          <line x1="20" y1="41" x2="38" y2="41" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
      )
    },
    {
      title: 'AI/LLM Model Deployment',
      description: 'Deployed AI/LLM models in GCP (Vertex AI) and Azure OpenAI, building real-time inference pipelines. Integrated ML workloads into production systems with automated scaling and monitoring.',
      technologies: ['Vertex AI', 'Azure OpenAI', 'GCP', 'Python'],
      icon: (
        <svg viewBox="0 0 60 60" fill="none">
          <circle cx="30" cy="30" r="20" stroke="currentColor" strokeWidth="2"/>
          <circle cx="30" cy="30" r="8" fill="currentColor"/>
          <path d="M30 10 L30 5 M30 50 L30 55 M10 30 L5 30 M50 30 L55 30" stroke="currentColor" strokeWidth="2"/>
          <circle cx="30" cy="10" r="3" fill="currentColor"/>
          <circle cx="30" cy="50" r="3" fill="currentColor"/>
          <circle cx="10" cy="30" r="3" fill="currentColor"/>
          <circle cx="50" cy="30" r="3" fill="currentColor"/>
        </svg>
      )
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2 className="section-title">
          <span className="section-number"></span>Featured Projects & Achievements</h2>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card" style={{animationDelay: `${index * 0.1}s`}}>
              <div className="project-icon">
                {project.icon}
              </div>
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-tech">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-badge">{tech}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;

